<template v-if="user_role == 1">
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <template v-for="(menu, m_index) in menuArray">
                <li v-bind:key="'m menu ' + m_index" :id="menu.slug" :class="['menuCommon', menu.slug, { active: menu.isActive }]">
                    <template v-if="menu.routerlink.name == 'BackendDocuments'">
                        <router-link v-bind:to="{name: menu.routerlink.name, params: { slug: menu.slug }}">
                            <i :class="'spm-nav-menu fa-stack fa-lg ' + menu.icon"></i>
                            <p>{{stringTrim(menu.name, 22)}}</p>
                        </router-link>
                    </template>
                    <template v-else>
                        <router-link v-bind:to="{name: menu.routerlink.name}">
                            <i :class="'spm-nav-menu fa-stack fa-lg ' + menu.icon"></i>
                            <p>{{stringTrim(menu.name, 22)}}</p>
                        </router-link>
                    </template>
                </li>
            </template>
        </ul>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from '.././event-bus';
    import BootstrapVue from 'bootstrap-vue';

    Vue.use(BootstrapVue);
    var self;
    export default {
        name: 'Sidebar',
        mixins: [commonMixins],
        data() {
            return {
                user_role:localStorage.getItem("user_role"),
                menuArr: [],
                loginUserPermission: ['qr_code_scan_list', 'user_access', 'qr_code_generate'],
                // loginUserPermission: [],
                menuArray: [
                    {
                        name: "News & Announcements",
                        slug: "news-announcement",
                        routerlink: {
                            name: "ListNewsAnnouncements"
                        },
                        icon: "icon-procedures",
                        isActive: false,
                        ref: "news-announcement",
                        id: "news-announcement"
                    },
                    {
                        name: "Events",
                        slug: "events",
                        routerlink: {
                            name: "ListEvents"
                        },
                        icon: "icon-Save-the-Date",
                        isActive: false,
                        ref: "events",
                        id: "events"
                    },
                    {
                        name: "Policies",
                        slug: "policies",
                        routerlink: {
                            name: "BackendDocuments",
                        },
                        icon: "icon-warranty",
                        isActive: false,
                        ref: "policies",
                        id: "policies"
                    },
                    {
                        name: "Code of Conduct",
                        slug: "code-of-conduct",
                        routerlink: {
                            name: "BackendDocuments",
                        },
                        icon: "icon-Sales-Programs",
                        isActive: false,
                        ref: "code-of-conduct",
                        id: "code-of-conduct"
                    },
                    {
                        name: "Projects",
                        slug: "projects",
                        routerlink: {
                            name: "BackendDocuments",
                        },
                        icon: "icon-Sales-1",
                        isActive: false,
                        ref: "projects",
                        id: "projects"
                    },
                    {
                        name: "Users",
                        slug: "users",
                        routerlink: {
                            name: "ListUsers",
                        },
                        icon: "fa fa-user-o",
                        isActive: false,
                        ref: "users",
                        id: "users"
                    },
                    {
                        name: "Report Problem Mails",
                        slug: "report-problem-mails",
                        routerlink: {
                            name: "ListReportProblemMail",
                        },
                        icon: "fa fa-envelope-open-o",
                        isActive: false,
                        ref: "report-problem-mails",
                        id: "report-problem-mails"
                    },
                    {
                        name: "Opinion Matter Mails",
                        slug: "opinion-matter-mails",
                        routerlink: {
                            name: "ListOpinionMatterMail",
                        },
                        icon: "fa fa-envelope-o",
                        isActive: false,
                        ref: "opinion-matter-mails",
                        id: "opinion-matter-mails"
                    },
                    {
                        name: "Search Logs",
                        slug: "search-logs",
                        routerlink: {
                            name: "ListSearchLog",
                        },
                        icon: "fa fa-search",
                        isActive: false,
                        ref: "search-logs",
                        id: "search-logs"
                    }
                ],
            }

        },
        beforeMount: function () {
            // self.loginUserPermission = [];
        },
        mounted: function () {
            self = this;
            $("#menu-toggle").click(function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });
        },
        methods: {

        }
    };

    EventBus.$on("menu-selection-changed", function (menuref) {
        if (typeof self != "undefined") {
            for (var i = 0; i < self.menuArray.length; i++) {
                var menuObject = self.menuArray[i];
                if (menuref == menuObject.ref) {
                    menuObject.isActive = true;
                } else {
                    menuObject.isActive = false;
                }
            }
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/partials/Sidebar.vue